import { InputText, Popup } from '@ui/src';
import { DocumentsPopupsTypes } from '../types';

import cn from '../styles.module.css';

const DocumentsPopups = ({
  selectedCategory,
  allDocumentsSelected,
  selectedDocumentsCountByCategory,
  setDeletePopupVisible,
  documentsByCategoryId,
  allowedCategories,
  allDocuments,
  deleteInProgress,
  deletePopupVisible,
  onDelete,
  setRenamePopupVisible,
  setSelectedDocumentToRename,
  setDocumentName,
  setNameError,
  onRename,
  documentRenameInProgress,
  renamePopupVisible,
  documentName,
  selectedDocumentToRename,
  nameError,
  errors,
}: DocumentsPopupsTypes) => (
  <>
    <Popup
      title={`Delete ${
        selectedCategory && selectedCategory?.id === 'all'
          ? allDocumentsSelected
          : selectedDocumentsCountByCategory
      } documents?`}
      onCancelClick={() => {
        setDeletePopupVisible(false);
      }}
      onOkClick={() => {
        const selectedIds: string[] = [];

        if (documentsByCategoryId && allowedCategories) {
          allowedCategories.forEach((item) => {
            if (documentsByCategoryId[item.id]) {
              documentsByCategoryId[item.id].forEach((category) => {
                category.documents?.forEach((document) => {
                  if (document.isSelected) {
                    selectedIds.push(document.id);
                  }
                });
              });
            }
          });
        }

        if (allDocuments) {
          allDocuments.all.forEach((item) => {
            item.documents?.forEach((document) => {
              if (
                document.isSelected &&
                !selectedIds.find((id) => id === document.id)
              ) {
                selectedIds.push(document.id);
              }
            });
          });
        }

        onDelete(selectedIds);
      }}
      cancelButtonText="Cancel"
      okButtonText={deleteInProgress ? 'Loading...' : 'Delete'}
      isVisible={deletePopupVisible}
      isLoading={deleteInProgress}
    />
    <Popup
      title="Rename"
      onCancelClick={() => {
        setRenamePopupVisible(false);
        setSelectedDocumentToRename(undefined);
        setDocumentName('');
        setNameError('');
      }}
      onOkClick={onRename}
      cancelButtonText="Cancel"
      okButtonText={documentRenameInProgress ? 'Loading...' : 'Save'}
      isVisible={renamePopupVisible}
      isLoading={documentRenameInProgress}
      okButtonDisabled={documentName === selectedDocumentToRename?.name}
    >
      <InputText
        placeholder="Enter document name..."
        name="documentName"
        value={documentName}
        onChange={(e) => setDocumentName(e.target.value)}
        labelClassName={cn.renameInput}
        error={nameError || (errors?.name?.message as string)}
      />
    </Popup>
  </>
);

export default DocumentsPopups;
